export { default } from './UserInfoBlock';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/UserProfile/UserInfoBlock/index.js